import { singleton } from "tsyringe";

import type {
    SimplifiedSubmittedActionDto,
    SimplifiedSubmittedAnswerDto,
} from "@/entities/submitted-action/domain/dtos";
import { SubmittedActionType } from "@/entities/submitted-action/domain/enums";

export interface SubmittedActionBehaviorStructure {
    isSimplifiedSubmittedAnswer: (
        simplifiedSubmittedActionDto: SimplifiedSubmittedActionDto,
    ) => simplifiedSubmittedActionDto is SimplifiedSubmittedAnswerDto;
}

@singleton()
export class SubmittedActionBehavior implements SubmittedActionBehaviorStructure {
    public isSimplifiedSubmittedAnswer = (
        simplifiedSubmittedActionDto: SimplifiedSubmittedActionDto,
    ): simplifiedSubmittedActionDto is SimplifiedSubmittedAnswerDto => {
        return simplifiedSubmittedActionDto.type === SubmittedActionType.Answer;
    };
}
